import React, { createContext, useContext, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

import { KeyValue } from "@/main/models/common";

interface ISupplierRegisterContext {
	isEdit: boolean;
	setIsEdit: (value: boolean) => void;
	displaySaveSupplier: () => void;
	displayEditSupplier: () => void;
}

interface ISupplierRegisterProvider {
	children: React.ReactNode;
}

const INITIAL_FORM_STATE = {
	country: null as KeyValue | null,
	companyName: "",
	rfc: "",
	status: null as KeyValue | null,
	assignedBodyShop: null as string | null,
	tradeName: "",
	supplierCategory: null as KeyValue | null,
};

export type ISupplierRegisterForm = typeof INITIAL_FORM_STATE;

const SupplierRegisterContext = createContext<ISupplierRegisterContext>({
	isEdit: false,
	setIsEdit: () => {},
	displaySaveSupplier: () => {},
	displayEditSupplier: () => {},
});

function SupplierRegisterProvider({ children }: ISupplierRegisterProvider) {
	const methods = useForm<ISupplierRegisterForm>({
		mode: "onChange",
		defaultValues: INITIAL_FORM_STATE,
	});

	const [isEdit, setIsEdit] = useState(false);

	function displaySaveSupplier() {}
	function displayEditSupplier() {}

	const supplierContextValue = useMemo(
		() => ({
			isEdit,
			setIsEdit,
			displaySaveSupplier,
			displayEditSupplier,
		}),
		[isEdit],
	);
	return (
		<FormProvider {...methods}>
			<SupplierRegisterContext.Provider value={supplierContextValue}>{children}</SupplierRegisterContext.Provider>
		</FormProvider>
	);
}

const useSupplierRegisterContext = () => useContext(SupplierRegisterContext);

export { SupplierRegisterProvider, useSupplierRegisterContext };
